import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { DetailsPanel } from "@/components/common";
import {
  TraceMatrixContent,
  TraceMatrixTraces,
  TraceMatrixArtifacts,
} from "@/components/traceMatrix/display";
import { TraceMatrixButtons } from "@/components/traceMatrix/save";

/**
 * Displays trace matrix information.
 */
const __default__ = {
  name: "TraceMatrixPanel",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DetailsPanel), { panel: "displayTraceMatrix" }, {
    actions: _withCtx(() => [
      _createVNode(_unref(TraceMatrixButtons))
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(TraceMatrixContent)),
      _createVNode(_unref(TraceMatrixTraces)),
      _createVNode(_unref(TraceMatrixArtifacts))
    ]),
    _: 1
  }))
}
}

})